import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/AmusementServiceReserveItemGroup`;


const ApiAmusementServiceReserveItemGroup = {
    getAll: (params) => {
    const url = `${baseServiceUrl}`;
    return ServiceApi.get(url, { params });
  },
  getAllReserveItemGroups: (serviceId) => {
    const url = `${baseServiceUrl}/getAllAmusementReserveItemGroups/${serviceId}`;
    return ServiceApi.get(url);
  },
  get: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    return ServiceApi.get(url);
  },
  create: (params) => {
    const url = `${baseServiceUrl}/create-amusementServiceReserveItemGroup`;
    return ServiceApi.post(url, params);
  },
  update: (id, params) => {
    const url = `${baseServiceUrl}/update-amusementServiceReserveItemGroup`;
    return ServiceApi.put(url, params);
  },
    changeOrderAmusementServiceReserveItemGroup: (params) => {
    const url = `${baseServiceUrl}/changeOrderAmusementServiceReserveItemGroups`;
    return ServiceApi.post(url,  params );
  },
};

export default ApiAmusementServiceReserveItemGroup;


